











import { Component, Vue, Prop, } from 'vue-property-decorator';

@Component
export default class TagBox extends Vue {
	@Prop() public value: string;
	@Prop({default: 65}) public width: number;
	@Prop({default: 36}) public height: number;
	@Prop({default: 1}) public border: number;
	@Prop({default: 'middle'}) public align: 'left' | 'middle';

	public netcallSalmonColour = '#FF6666';

	public get boxPath() {
		return `M${this.width} 0 H0 V${this.height} H${this.width}`;
	}

	public get arrowPath() {
		return `M${this.width} ${this.height} L${this.widthWithArrow} ${this.height / 2} L${this.width} 0`;
	}

	public get widthWithArrow() {
		return this.width + 10;
	}

	public get textBaseline() {
		return (this.height / 2) + (this.border * 2);
	}

	public get textX() {
	  return this.align === 'left' ? 10 : this.width / 2;
  }
}
